import { theme } from '../constants/defaults';
import { formatMoney } from '../utils/product';

const lang = document.getElementsByTagName('html')[0].getAttribute('lang');

export function renderNote(note) {
  if (!theme.settings.cartNotes) {
    return '';
  }

  return `
    <div class="input-group">
      <p class="accordion__title special-instructions__title" onclick="(function(){
        const accordionActive = 'accordion__title--active';
        const trigger = document.querySelector('.special-instructions__title');
        const content = trigger.nextElementSibling;

        if (!trigger.classList.contains(accordionActive)) {
          trigger.classList.add(accordionActive);
          content.style.height = '200px';
        } else {
          trigger.classList.remove(accordionActive);
          content.style.height = 0;
        }

        return false;})();return false;">
        <svg class="icon icon-note">
          <use xlink:href="#icon-note"/>
        </svg>
        ${theme.strings.cart_note}
      </p>

      <div class="accordion__content">
        <textarea name="note" id="CartSpecialInstructions" class="textarea">${note || ''}</textarea>
      </div>

    </div>
  `;
}

export function renderUpsell(state) {
  const upsellProducts = window.cartUpsell;

  if (upsellProducts.length > 0) {
    if (!theme.settings.cartUpsell) {
      return '';
    }

    const cartItemIds = state.items.map((item) => item.product_id);

    let productSlides = '';

    upsellProducts.forEach((upsellProduct) => {
      if (cartItemIds.indexOf(upsellProduct.id) === -1) {
        productSlides += `<div class="swiper-slide">
            <div class="ajaxcart__upsell">
              <div class="ajaxcart__upsell-product">
                <div class="product-item__visual">
                  <div class="visual">
                    <img src="${upsellProduct.featured_image}" alt="" loading="lazy">
                  </div>
                </div>

                <div class="ajaxcart__upsell-wrapper">
                  <p class="ajaxcart__product-info">
                    <a href="${lang === 'en' ? '' : `/${lang}`}/products/${
          upsellProduct.handle
        }" class="ajaxcart__product-name">
                      ${upsellProduct.title}
                    </a>
                  </p>
                  <div class="btn btn-mini text-center js-add-to-cart-button button--upsell" data-variantid="${
                    upsellProduct.variants[0].id
                  }">
                    <svg class="icon icon-cart">
                      <use xlink:href="#icon-cart"/>
                    </svg>
                    <span>${theme.strings.cart_quick_add}</span>
                  </div>

                </div>

                <div class="ajaxcart__price-wrapper">
                  <span class="ajaxcart__price">€${upsellProduct.variants[0].price / 100}</span>
                </div>
              </div>
            </div>
          </div>`;
      }
    });

    return `
      <p class="ajaxcart__upsell-title">${theme.strings.cart_upsell}</p>

      <div class="slider slider--upsell__wrapper | js-slider" data-config="upsell-slider">
        <div class="swiper-container slider--upsell">
          <div class="swiper-wrapper">

          ${productSlides}

          </div>
        </div>

        <div class="swiper-button-next-upsell">
          <svg class="icon icon-arrow-down">
            <use xlink:href="#icon-arrow-down"/>
          </svg>
        </div>
        <div class="swiper-button-prev-upsell">
          <svg class="icon icon-arrow-down">
            <use xlink:href="#icon-arrow-down"/>
          </svg>
        </div>

      </div>
    `;
  }
  return '';
}

export function renderFooter(state, note) {
  const { total_price: totalPrice, total_discount: totalDiscount } = state;

  return `
    <div class="ajaxcart__footer">
      ${renderNote(note)}
      <div class="grid grid--gutter-0">
        <div class="grid__item two-thirds">
          <p class="ajaxcart__total-price-title">${theme.strings.cart_subtotal}</p>
        </div>
        <div class="grid__item one-third text-right">
          <p class="ajaxcart__total-price">${formatMoney(totalPrice)}</p>
        </div>

      </div>
      <p class="ajaxcart__shipping-text">${theme.strings.cart_shipping_at_checkout}</p>
      ${
        totalDiscount
          ? `
            <p class="ajaxcart__savings text-center">
              <em>${theme.strings.cart_savings.replace(
                '[savings]',
                formatMoney(totalDiscount),
              )}</em>
            </p>
          `
          : ''
      }
      <button type="submit" class="button button--full button--cart | js-loading-button" name="checkout">
        ${theme.strings.cart_checkout}
      </button>

      ${renderUpsell(state)}

    </div>
  `;
}
